export function Launcher({
  open,
  onClick,
  themeColor,
}: {
  open: boolean;
  onClick: () => void;
  themeColor: string;
}) {
  return (
    <button
      type="button"
      className={`cbm-launcher ${open ? 'cbm-launcher--open' : 'cbm-launcher--closed'}`}
      aria-label={open ? 'Κλείσιμο συνομιλίας' : 'Άνοιγμα συνομιλίας'}
      onClick={onClick}
      style={{ backgroundColor: themeColor }}
    >
      {open ? (
        '×'
      ) : (
        <svg
          className="cbm-launcher__icon"
          viewBox="0 0 24 24"
          aria-hidden="true"
          focusable="false"
          fill="none"
        >
          <path
            d="M7.75 6.75h8.5a2.75 2.75 0 0 1 2.75 2.75v4.75A2.75 2.75 0 0 1 16.25 17H11.2L7 20.15V17H7.75A2.75 2.75 0 0 1 5 14.25V9.5a2.75 2.75 0 0 1 2.75-2.75Z"
            stroke="currentColor"
            strokeWidth="1.8"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <circle cx="9.5" cy="11.75" r="1" fill="currentColor" />
          <circle cx="12" cy="11.75" r="1" fill="currentColor" />
          <circle cx="14.5" cy="11.75" r="1" fill="currentColor" />
        </svg>
      )}
    </button>
  );
}
